import { WorkflowElement } from "../element"
import { extend } from "lodash"

export class Panel extends WorkflowElement {
  static get elementName() {
    return "workflow-panel"
  }

  initialize(caller) {
    this.onload = this.onload.bind(this)
    this.receive = this.receive.bind(this)
    if (!caller) {
      return
    }

    if (caller.dataset.url) {
      this.dataset.url = caller.dataset.url
    }

    if (caller.dataset.action) {
      this.dataset.action = caller.dataset.action
    }

    if (caller.dataset.node) {
      this.dataset.node = this.data(caller)
    }
  }

  connectedCallback() {
    const iframe = this.find("iframe")
    iframe.onload = this.onload
    iframe.src = this.dataset.url
    window.addEventListener("message", this.receive)

    this.dataset.loading = true
    this.dispatchEvent(
      new CustomEvent("workflow-panel:start-loading", { bubbles: true })
    )
  }

  deconnectedCallback() {
    window.removeEventListener("message", this.receive)
  }

  create(event) {
    this.dispatchEvent(
      new CustomEvent("workflow-node:submit", {
        bubbles: true,
        detail: {
          origin: "panel",
          action: "/workflows/nodes",
          method: "POST",
          body: extend(JSON.parse(this.dataset.node), event.data)
        }
      })
    )
  }

  update(event) {
    this.dispatchEvent(
      new CustomEvent("workflow-node:update", {
        bubbles: true,
        detail: event.data
      })
    )
  }

  receive(event) {
    if (event.data.context !== "workflow") {
      return
    }

    if (this.dataset.action === "create") {
      this.dataset.action = "update"
      this.create(event)
      return
    }
    this.update(event)
  }

  onload() {
    this.dispatchEvent(
      new CustomEvent("workflow-panel:stop-loading", { bubbles: true })
    )

    window.scroll({
      top: 0,
      behavior: "smooth"
    })
  }

  data(caller) {
    const data = JSON.parse(caller.dataset.node)
    if (caller.dataset.sources) {
      data.sources = caller.dataset.sources
    }

    if (caller.dataset.condition) {
      data.condition = caller.dataset.condition
    }

    return JSON.stringify(data)
  }
}

customElements.get("workflow-panel") ||
  customElements.define("workflow-panel", Panel)
